<template>
  <div class="main special">
    <div class="nav" v-if="article.type == 1">
      <div class="left">
        <div @click="$router.go(-1)" class="icon_back"></div>
      </div>
      专题文章
    </div>
    <div class="nav" v-if="specialList.type == 2">
      <div class="left">
        <div @click="$router.go(-1)" class="icon_back"></div>
      </div>
      专题详情
    </div>
    <div class="content" v-if="article.type == 1">
      <div v-html="article.content"></div>
    </div>
    <div class="content" v-if="specialList.type == 2">
      <div class="banner_bg">
        <div class="banner_img">
          <img :src="specialList.cover_img || specialList.vision_img" alt="" />
        </div>
      </div>
      <div class="detailList_box">
        <div
          class="detailList_bg"
          v-for="(item, index) in specialList.content"
          :key="index"
          @click="goToNovel(item)"
          v-bind:style="{
            background: 'url(' + item.fiction_bottom_img + ')',
            backgroundSize: '100% 100%',
          }"
        >
          <div
            class="detailList"
            v-bind:style="
              item.fiction_bottom_img == null ? 'background: #f1f1f1' : ''
            "
          >
            <div class="img_info">
              <img :src="item.fiction_cover_img" alt="" />
            </div>
            <div class="img_text">
              <p
                v-bind:style="{
                  fontSize: item.fiction_title_font_size + 'px',
                  color: '#' + item.fiction_title_color,
                }"
              >
                {{ item.fiction_title }}
              </p>
              <div class="exhibition" v-if="item.fiction_anchor_raido == 1">
                <span
                  v-bind:style="{
                    fontSize: item.fiction_description_font_size + 'px',
                    color: '#' + item.fiction_description_color,
                  }"
                >
                  作者：{{ item.fiction_anchor_text }}
                </span>
              </div>
              <p
                v-bind:style="{
                  fontSize: item.fiction_description_font_size + 'px',
                  color: '#' + item.fiction_description_color,
                }"
              >
                {{ item.fiction_description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapState, mapMutations, mapActions } from "vuex";
import "../css/special.scss";
export default {
  name: "specialDesc",
  data() {
    return {
      specialList: {},
      article: {},
    };
  },
  computed: {
    ...mapState("userIndex", ["topicDetail", "specialId"]),
  },
  created() {
    this.setSpecialId(this.$route.params.id);
    this.fetchTopic().then((res) => {
      // console.log(res)
      this.specialList = res.data;
      this.article = res.data;
    });
    //this.fetchTopic()
  },
  methods: {
    ...mapActions("userIndex", ["fetchTopic"]),
    ...mapMutations("userIndex", ["setTopicDetail", "setSpecialId"]),
    goToNovel(item) {
      this.$router.push({
        path: "/fictionList",
        query: {
          nid: item.fiction_id,
          platform: this.$route.query.platform,
          ver: this.$route.query.ver,
        },
      });
    },
  },
};
</script>
  